// extracted by mini-css-extract-plugin
export default {"bannerContainer":"BrowseItemsBannerV2_bannerContainer__RFOr5","bannerImageContainer":"BrowseItemsBannerV2_bannerImageContainer__iRipF"};